<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header">
      {{newEvaluation.title}}
    </span>
  </div>
  @if (newEvaluation.configuredSteps && newEvaluation.steps.length !== 1) {
    <wizard-steps
      class="px-xxl pb-md"
      [steps]="newEvaluation.steps"
      [state]="newEvaluation.wizardState">
    </wizard-steps>
  }
  @if (skin === 'steel-blue' && newEvaluation.productId === 'blanqueo' && newEvaluation.wizardState >= 4) {
    <span
      [afTranslate]="'new-evaluation.transaction-not-verify'"
      class="common-evaluation__article-text block font-mtt-milano text-[16px] leading-[20px] py-[6px]">
      _De conformidad con el artículo 5...
    </span>
  }
  @if (newEvaluation.configuredSteps) {
    @switch (newEvaluation.wizardState) {
      @case (1) {
        <div class="flex flex-col gap-md"
          [ngClass]="{'new-evaluation__block-clients': (newEvaluation.repeatedSelectedClient || newEvaluation.clientSelector.noClientSelected) && newEvaluation.legalFormInfo}">
          <field-type-clients-selector
            [field]="newEvaluation.clientSelector"
            [productId]="newEvaluation.productId"
            [preSelectItem]="newEvaluation.createEvaluation.clientId"
            [chargedList]="newEvaluation.clients"
            (itemSelected)="clientSelected($event.value)"
            (showNoLicenseMessage)="updateClientLicenseStatus($event)">
          </field-type-clients-selector>
          @if (newEvaluation.legalFormInfo) {
            <field-type-list-simple
              [field]="newEvaluation.legalForm"
              [preSelectItem]="newEvaluation.createEvaluation.legalFormId"
              [listValues]="newEvaluation.legalFormsList"
              (itemSelected)="itemSelected($event.newValue, 'legalFormId')">
            </field-type-list-simple>
          }
          @if (newEvaluation.clientSelector.noClientSelected || (hasLicense === 2 && showNoLicenseMessage)) {
            <div class="common-status-message__g-container-alert">
              <i class="lf-icon-close-round-full common-status-message__icon-md">
              </i>
              <div class="common-status-message__g-content">
                <div class="common-status-message__g-icon-text-content">
                  <div class="common-status-message__g-title-subtitle">
                    @if (hasLicense === 2 && showNoLicenseMessage) {
                      <span
                        [innerHTML]="noLicenseMessage"
                        class="common-status-message__g-subtitle common-status-message__g-subtitle--with-link">
                      </span>
                    }
                    @else {
                      <span
                        [afTranslate]="'new-evaluation.assign-organization-variant'"
                        class="common-status-message__g-subtitle">
                        _Es necesario asignar la nueva implantación a un organización en concreto
                      </span>
                    }
                  </div>
                  <button class="common-button__icon-xs-noborder">
                    <i
                      (click)="restoreAlertMessage()"
                      class="lf-icon-close-thick common-icon__sm">
                    </i>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
      @case (2) {
        @if (newEvaluation.type != 'edit') {
          <div class="common-modal__form-container">
            <div class="common-container__mandatory-obligatory-message-form">
              <span class="common-tag__mandatory-text-asterisk">
                *
              </span>
              <span
                [afTranslate]="'common.required-fields'"
                class="common-tag__mandatory-label-text-obligatory-message">
                _Campos obligatorios
              </span>
            </div>
            <field-type-text-simple
              [field]="newEvaluation.evaluationName"
              [preSelectItem]="newEvaluation.createEvaluation.name"
              (itemSelected)="itemSelected($event.newValue, 'name')">
            </field-type-text-simple>
            <field-type-text-multiline
              [field]="newEvaluation.evaluationDescription"
              [preSelectItem]="newEvaluation.createEvaluation.description"
              (itemSelected)="itemSelected($event.newValue, 'description')">
            </field-type-text-multiline>
          </div>
        }
      }
      @default {
        <div class="common-modal__content-scroll max-h-[514px]">
          <div class="common-modal__form-container">
            <!-- Roles -->
            @if (newEvaluation.productHasAnyRoles && newEvaluation.wizardState === 3) {
              @for (role of newEvaluation.roles; track role) {
                <field-type-contacts
                  [field]="role"
                  [valueId]="newEvaluation.createEvaluation.productId"
                  (sendContacts)="receiveContacts($event.contacts, role)">
                </field-type-contacts>
              }
            } @else {
              @for (groupProperty of newEvaluation.groupPropertiesList; track $index) {
                @if (newEvaluation.wizardState - newEvaluation.propertiesIndex === $index) {
                  @for (property of groupProperty; track property) {
                    @if (property.isBoolean && property.showWithProperty) {
                      <field-type-bool
                        [preSelectItem]="property.preSelect"
                        [field]="property.listField"
                        (itemSelected)="selectBooleanOn($event, property)">
                      </field-type-bool>
                    }
                    @if (!property.isText && !property.isBoolean && property.showWithProperty) {
                      @if (!property.isExtendedList && property.isMultiple) {
                        <field-type-list-multiple
                          [field]="property.listField"
                          [preSelectItem]="property.preSelect"
                          [listValues]="property.listValues"
                          (itemSelected)="propertySelectedOn($event, property)">
                        </field-type-list-multiple>
                      }
                      @if (!property.isExtendedList && !property.isMultiple) {
                        <field-type-list-simple
                          [field]="property.listField"
                          [preSelectItem]="property.preSelect"
                          [listValues]="property.listValues"
                          (itemSelected)="propertySelectedOn($event, property)">
                        </field-type-list-simple>
                      }
                      @if (property.isExtendedList) {
                        <field-type-list-extended
                          [field]="property.listField"
                          [preSelectItem]="property.preSelect"
                          [listValues]="property.listValues"
                          (itemSelected)="propertySelectedOn($event, property)">
                        </field-type-list-extended>
                      }
                    }
                  }
                }
              }
            }
          </div>
        </div>
      }
    }
  }
  <div class="common-modal__footer">
    <button
      [ngClass]="{
        'common-button__text-border': newEvaluation.wizardState == 1,
        'common-button__text-noborder': newEvaluation.wizardState > 1
      }"
      (click)="handleDismiss()">
      <span
        [afTranslate]="'common.cancel'"
        class="common-button__text-title">
        _Cancelar
      </span>
    </button>
    @if ((newEvaluation.wizardState > 1 && newEvaluation.type == 'new') || (newEvaluation.wizardState > 3 && newEvaluation.type == 'edit')) {
      <button
        class="common-button__text-border"
        (click)="goBack()">
        <span
          [afTranslate]="'common.previous'"
          class="common-button__text-title">
          _Anterior
        </span>
      </button>
    }
    <button
      class="common-button__text"
      (click)="goNext()">
      <span class="common-button__text-title">
        {{newEvaluation.activeText}}
      </span>
    </button>
  </div>
</div>
